import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ManagementTable from '../../../components/management/ManagementTable.js';
import { vouchers } from '../../../constants/mockData/managementMockData';
import Modal from 'react-bootstrap/Modal';


class GiftVouchers extends Component {
 constructor(props) {
   super(props);
   this.state = {
     vouchers: [...vouchers],
     showAddModal: false,
     voucher: {
       amount: '',
       expiry: '',
       assignedTo: '',
       active: true
     },
     error: '',
     searchTerm: ''
   };
 }


 _toggleAddModal = () => {
   this.setState({
     showAddModal: !this.state.showAddModal,
     error: '',
     voucher: {
       amount: '',
       expiry: '',
       assignedTo: '',
       active: true
     }
   });
 };


 _handleInputChange = (e) => {
   const { name, value, type, checked } = e.target;
   this.setState({
     voucher: {
       ...this.state.voucher,
       [name]: type === 'checkbox' ? checked : value
     }
   });
 };


 _handleFilterChange = (e) => {
   this.setState({ [e.target.name]: e.target.value });
 };


 _handleSave = () => {
   const { voucher, vouchers: currentVouchers } = this.state;
  
   if (!voucher.amount || !voucher.assignedTo) {
     this.setState({ error: 'Please enter both amount and user email.' });
     return;
   }


   // Generate a new unique code
   const newCode = 'CV' + Math.random().toString(36).substr(2, 6).toUpperCase();


   const newItem = {
     ...voucher,
     id: currentVouchers.length + 1,
     code: newCode,
     amount: parseFloat(voucher.amount),
     status: voucher.active ? 'Active' : 'Revoked'
   };


   this.setState({
     vouchers: [...currentVouchers, newItem],
     showAddModal: false
   });
 };


 _getFilteredData = () => {
   const { vouchers, searchTerm } = this.state;
   return vouchers.filter(v => {
     return (
       v.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
       v.assignedTo.toLowerCase().includes(searchTerm.toLowerCase())
     );
   });
 };


 _getColumns = () => [
   {
     Header: () => <strong className="header__clr">VOUCHER CODE</strong>,
     accessor: 'code',
     Cell: (row) => <span className="text-dark-75 font-weight-bold">{row.value}</span>
   },
   {
     Header: () => <strong className="header__clr">AMOUNT</strong>,
     accessor: 'amount',
     Cell: (row) => <span>€{row.value.toFixed(2)}</span>
   },
   {
     Header: () => <strong className="header__clr">ASSIGNED TO</strong>,
     accessor: 'assignedTo'
   },
   {
     Header: () => <strong className="header__clr">EXPIRY</strong>,
     accessor: 'expiry'
   },
   {
     Header: () => <strong className="header__clr">STATUS</strong>,
     accessor: 'status',
     Cell: (row) => {
       let labelClass = 'label-light-success';
       if (row.value === 'Used') labelClass = 'label-light-warning';
       if (row.value === 'Revoked') labelClass = 'label-light-danger';
       return (
         <span className={`label label-inline label-pill ${labelClass}`}>
           {row.value}
         </span>
       );
     }
   },
   {
     Header: () => <strong className="header__clr">ACTIONS</strong>,
     sortable: false,
     Cell: () => (
       <>
         <button className="btn btn-icon btn-sm btn-light-primary mr-2" title="Revoke">
           <i className="la la-ban"></i>
         </button>
         <button className="btn btn-icon btn-sm btn-light-danger" title="Delete">
           <i className="la la-trash"></i>
         </button>
       </>
     )
   }
 ];


 render() {
   const { showAddModal, voucher } = this.state;


   return (
     <div className="container">
       <ManagementTable
         title="Gift Vouchers"
         columns={this._getColumns()}
         data={this._getFilteredData()}
         renderToolbar={() => (
           <div className="card-toolbar d-flex align-items-center">
             <div className="input-icon mr-6" style={{ width: '250px' }}>
               <input
                 type="text"
                 className="form-control"
                 placeholder="Search voucher code or user..."
                 name="searchTerm"
                 value={this.state.searchTerm}
                 onChange={this._handleFilterChange}
               />
               <span>
                 <i className="flaticon2-search-1 text-muted"></i>
               </span>
             </div>
             <button className="btn btn-primary font-weight-bolder" onClick={this._toggleAddModal}>
               <span className="svg-icon svg-icon-md mr-1">
                 <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                   <rect x="0" y="0" width="24" height="24" fill="none"/>
                   <circle fill="#000000" cx="9" cy="15" r="6"/>
                   <path d="M8.8012943,7.00241953 C9.83837775,5.20768121 11.7781543,4 14,4 C17.3137085,4 20,6.6862915 20,10 C20,12.2218457 18.7923188,14.1616223 16.9975805,15.1987057 C16.9991904,15.1326658 17,15.0664274 17,15 C17,10.581722 13.418278,7 9,7 C8.93357256,7 8.86733422,7.00080962 8.8012943,7.00241953 Z" fill="#000000" opacity="0.3"/>
                 </svg>
               </span>
               Create Voucher
             </button>
           </div>
         )}
       />


       <Modal show={showAddModal} onHide={this._toggleAddModal}>
         <Modal.Header closeButton>
           <Modal.Title>Create Gift Voucher</Modal.Title>
         </Modal.Header>
         <Modal.Body>
           {this.state.error && (
             <div className="alert alert-custom alert-light-danger fade show mb-5" role="alert">
               <div className="alert-text">{this.state.error}</div>
             </div>
           )}
           <div className="form-group">
             <label>Amount (€)</label>
             <input type="number" className="form-control" name="amount" value={voucher.amount} onChange={this._handleInputChange} />
           </div>
           <div className="form-group">
             <label>Expiry Date</label>
             <input type="date" className="form-control" name="expiry" value={voucher.expiry} onChange={this._handleInputChange} />
           </div>
           <div className="form-group">
             <label>Assign to User (Email)</label>
             <input type="email" className="form-control" name="assignedTo" value={voucher.assignedTo} onChange={this._handleInputChange} />
           </div>
           <div className="form-group">
             <label className="checkbox checkbox-outline checkbox-success">
               <input type="checkbox" name="active" checked={voucher.active} onChange={this._handleInputChange} />
               <span></span>
               Active
             </label>
           </div>
         </Modal.Body>
         <Modal.Footer>
           <button className="btn btn-secondary" onClick={this._toggleAddModal}>Cancel</button>
           <button className="btn btn-primary" onClick={this._handleSave}>Save Voucher</button>
         </Modal.Footer>
       </Modal>
     </div>
   );
 }
}


export default withRouter(GiftVouchers);


